import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { IIDataPointsConfigResponse } from '../store/configurations.types'
import { ConfigurationsService } from '../services/configurations.service'
import * as actions from '../store/configurations.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* setDatasetDeterminationConfig() {
  const serviceId: string = yield select(getServiceIdSelector)
  const configurationsService = new ConfigurationsService(serviceId)
  try {
    const response: IIDataPointsConfigResponse = yield call([
      configurationsService,
      configurationsService.getDatasetDeterminationConfig,
    ])
    const { entity } = response
    if (entity && entity.length) {
      yield put(actions.setDatasetDeterminationConfig(entity[0]))
      yield put(actions.setInitialExportDatasets())
    }
  } catch (e) {
    yield put(throwPcrException(`setDatasetDeterminationConfig() error: ${e}`))
  }
}
export function* setDatasetDeterminationConfigSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setDatasetDeterminationConfig)
}
